export const siteInfo = {
  name: '妖精影院',
  slogan: '免费看 · 不缓冲 · 高清全集',
  intro: '妖精影院是国内领先的免费在线观看平台，每日同步更新海量高清电影、电视剧全集与热门综艺。我们致力于为影迷提供流畅不卡顿的观影体验，无需注册付费即可畅享全站资源。无论是最新上映的院线大片、经典怀旧剧集，还是当下热播的口碑新剧，在妖精影院都能一键直达、即点即播。',
  tagline: '你的私人影院，永远免费',
  stats: [
    { label: '每日更新', value: '200+ 部' },
    { label: '高清片源', value: '10万+ 部' },
    { label: '同时在线', value: '50万+ 人' },
  ],
};

export const aboutData = {
  title: '关于妖精影院',
  content: '妖精影院创立于2019年，经过多年深耕，已发展成为覆盖电影、电视剧、综艺、动漫、纪录片等全品类的高清免费在线观看平台。我们采用分布式CDN加速与智能转码技术，确保每一位用户都能享受流畅不缓冲的极致观影体验。平台坚持免费模式，依靠口碑传播积累了千万级忠实用户，是您追剧看片的首选之地。',
};

export const contactData = {
  title: '联系我们',
  description: '如有影片推荐、片源投稿或合作事宜，欢迎通过以下方式与我们联系。我们珍视每一位影迷的声音。',
  email: 'contact@yaojingcinema.com',
  wechat: '妖精影院官方',
  qq: '88888888',
};

export const appData = {
  title: '随时随地 · 掌上看片',
  description: '妖精影院移动端已覆盖iOS与Android双平台。支持离线缓存、投屏播放、夜间模式等贴心功能，让你在地铁、旅途中也能畅快追剧。',
  features: ['离线缓存随时看', '一键投屏大屏享受', '智能推荐猜你喜欢', '纯净无广告体验'],
};

export const commentsData = [
  {
    id: 1,
    name: '电影发烧友阿强',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20casual%20style%20warm%20lighting%20friendly%20expression%20clean%20background%20professional%20headshot&width=120&height=120&seq=avatar-01&orientation=squarish',
    comment: '用了妖精影院三年了，片源更新速度真的没话说。昨天晚上电影院刚上映的片子，今天早上就有高清版了，画质清晰还不卡顿，强烈推荐给所有爱看电影的朋友！',
    time: '2小时前',
    likes: 1286,
  },
  {
    id: 2,
    name: '追剧小达人Luna',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20natural%20look%20warm%20smile%20casual%20outfit%20clean%20studio%20background%20soft%20lighting&width=120&height=120&seq=avatar-02&orientation=squarish',
    comment: '终于找到一个不收费不弹窗的追剧平台了！界面简洁大方，分类也很清晰，想看的剧搜一下就有，全集一次性放出不用等更新，简直是追剧人的天堂～',
    time: '5小时前',
    likes: 956,
  },
  {
    id: 3,
    name: '老片收藏家',
    avatar: 'https://readdy.ai/api/search-image?query=middle%20aged%20Chinese%20man%20portrait%20warm%20expression%20glasses%20casual%20style%20clean%20background%20soft%20lighting%20professional&width=120&height=120&seq=avatar-03&orientation=squarish',
    comment: '作为一个怀旧影迷，最惊喜的是在这里找到了很多八九十年代的经典老片，画质修复得很不错。分类索引做得特别好，按年代、类型、地区都能快速定位，收藏功能也很实用。',
    time: '昨天',
    likes: 723,
  },
];

export const cardsData = [
  {
    id: 1,
    title: '悬疑剧场：烧脑合集',
    desc: '高分悬疑推理剧一次性放出，反转不断让你欲罢不能',
    tag: '热门专题',
    image: 'https://readdy.ai/api/search-image?query=dark%20mysterious%20cinematic%20scene%20with%20warm%20golden%20accents%20film%20noir%20atmosphere%20detective%20silhouette%20dramatic%20lighting%20movie%20poster%20style%20elegant%20composition%20deep%20red%20and%20black%20tones&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '国产好剧：口碑佳作',
    desc: '豆瓣8分以上的国产电视剧，部部经典值得反复品味',
    tag: '高分推荐',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20cinematic%20scene%20elegant%20traditional%20setting%20warm%20candlelight%20rich%20textures%20film%20poster%20style%20artistic%20composition%20deep%20red%20and%20gold%20tones&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '院线大片：最新上线',
    desc: '2026年暑期档热门影片第一时间同步更新，高清画质呈现',
    tag: '最新上架',
    image: 'https://readdy.ai/api/search-image?query=modern%20cinema%20marquee%20with%20warm%20neon%20lights%20red%20velvet%20curtains%20movie%20theater%20atmosphere%20glamorous%20hollywood%20style%20rich%20golden%20and%20crimson%20tones%20cinematic%20composition&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '日韩剧场：热门连载',
    desc: '最新日韩剧同步更新，中文字幕高清版本极速上线',
    tag: '海外精选',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20Korean%20drama%20cinematic%20scene%20cherry%20blossom%20romantic%20atmosphere%20warm%20soft%20lighting%20elegant%20composition%20film%20poster%20style%20delicate%20color%20palette&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '动漫专区：热血番剧',
    desc: '人气动漫番剧一网打尽，日更周更不停歇，追番必备',
    tag: '二次元',
    image: 'https://readdy.ai/api/search-image?query=anime%20style%20cinematic%20illustration%20vibrant%20colors%20dynamic%20composition%20action%20scene%20inspired%20warm%20golden%20and%20red%20accents%20artistic%20poster%20design%20clean%20background&width=800&height=500&seq=card-05&orientation=landscape',
  },
];

export const rankingData = [
  { id: 1, title: '暗夜追踪', type: '电影 · 动作悬疑', heat: '🔥 987万', rank: 1 },
  { id: 2, title: '春日暖阳', type: '电视剧 · 都市情感', heat: '🔥 876万', rank: 2 },
  { id: 3, title: '星辰大海第二季', type: '电视剧 · 科幻冒险', heat: '🔥 765万', rank: 3 },
  { id: 4, title: '笑傲江湖之风云再起', type: '电影 · 武侠喜剧', heat: '🔥 654万', rank: 4 },
  { id: 5, title: '秘境探险实录', type: '纪录片 · 自然探索', heat: '🔥 543万', rank: 5 },
];

export const mediaData = [
  {
    id: 1,
    title: '独家策划：2026暑期档观影指南',
    desc: '最值得期待的十部新片抢先看',
    thumb: 'https://readdy.ai/api/search-image?query=summer%20cinema%20guide%20editorial%20scene%20movie%20tickets%20and%20popcorn%20on%20wooden%20table%20warm%20cinematic%20lighting%20red%20velvet%20background%20elegant%20composition%20film%20poster%20aesthetic&width=640&height=360&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '经典重温：那些年我们追过的港片',
    desc: '黄金时代香港电影回顾特辑',
    thumb: 'https://readdy.ai/api/search-image?query=retro%20Hong%20Kong%20cinema%20nostalgic%20scene%20old%20film%20posters%20on%20brick%20wall%20warm%20vintage%20lighting%20golden%20and%20red%20tones%20classic%20movie%20aesthetic%20artistic%20composition&width=640&height=360&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '导演访谈：华语电影的新力量',
    desc: '年轻导演们的创作故事与心路历程',
    thumb: 'https://readdy.ai/api/search-image?query=director%20interview%20cinematic%20scene%20film%20set%20with%20warm%20lighting%20camera%20equipment%20artistic%20composition%20behind%20the%20scenes%20atmosphere%20rich%20golden%20tones%20elegant%20setting&width=640&height=360&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '追剧日历：八月新剧开播时间表',
    desc: '一键收藏本月所有新剧上线日期',
    thumb: 'https://readdy.ai/api/search-image?query=calendar%20with%20film%20strip%20design%20warm%20cinematic%20lighting%20movie%20clapperboard%20on%20desk%20elegant%20composition%20red%20and%20golden%20aesthetic%20creative%20editorial%20photography&width=640&height=360&seq=media-04&orientation=landscape',
  },
];

export const featuresData = [
  { id: 1, icon: 'ri-speed-line', title: '极速不缓冲', desc: '全球CDN加速节点覆盖，智能自适应码率，确保任何网络环境下都能流畅播放不卡顿' },
  { id: 2, icon: 'ri-film-line', title: '高清画质', desc: '支持1080P与4K超高清画质，HDR色彩增强技术带来影院级视觉享受' },
  { id: 3, icon: 'ri-play-circle-line', title: '即点即播', desc: '无需注册登录，无需下载客户端，打开网页就能直接观看，零门槛自由观影' },
  { id: 4, icon: 'ri-calendar-check-line', title: '每日更新', desc: '编辑团队7x24小时值守，新片上映后第一时间同步上线，追剧党永远不会错过更新' },
  { id: 5, icon: 'ri-shield-check-line', title: '安全纯净', desc: '全程HTTPS加密传输，无弹窗广告、无恶意跳转、无强制安装，守护您的观影安全' },
];

export const topicsData = [
  { id: 1, name: '悬疑烧脑', count: '1.2万讨论', color: 'bg-primary-100 text-primary-800' },
  { id: 2, name: '国产好剧推荐', count: '9.8千讨论', color: 'bg-accent-100 text-accent-800' },
  { id: 3, name: '高分韩剧', count: '8.5千讨论', color: 'bg-primary-100 text-primary-800' },
  { id: 4, name: '日漫新番', count: '7.2千讨论', color: 'bg-accent-100 text-accent-800' },
  { id: 5, name: '纪录片精选', count: '6.6千讨论', color: 'bg-secondary-100 text-secondary-800' },
  { id: 6, name: '科幻大片', count: '5.9千讨论', color: 'bg-primary-100 text-primary-800' },
  { id: 7, name: '经典老片修复', count: '5.3千讨论', color: 'bg-accent-100 text-accent-800' },
  { id: 8, name: 'NETFLIX热播', count: '4.8千讨论', color: 'bg-secondary-100 text-secondary-800' },
  { id: 9, name: '暑期档观影', count: '4.1千讨论', color: 'bg-primary-100 text-primary-800' },
];

export const indexData = [
  { id: 1, title: '动作电影大全', desc: '热血枪战、功夫格斗、极限追车', count: '1,286部', icon: 'ri-sword-line' },
  { id: 2, title: '喜剧电影合集', desc: '爆笑不断、轻松解压、欢乐时光', count: '952部', icon: 'ri-emotion-laugh-line' },
  { id: 3, title: '爱情电影专题', desc: '浪漫邂逅、心动瞬间、温情治愈', count: '1,108部', icon: 'ri-heart-line' },
  { id: 4, title: '恐怖惊悚片库', desc: '悬疑惊悚、午夜尖叫、胆小慎入', count: '634部', icon: 'ri-ghost-line' },
  { id: 5, title: '国产剧全集', desc: '热门国剧、口碑佳作、一网打尽', count: '2,451部', icon: 'ri-tv-line' },
  { id: 6, title: '韩剧专区', desc: '韩流热剧、高分韩剧、同步更新', count: '876部', icon: 'ri-heart-pulse-line' },,
  { id: 7, title: '动漫番剧库', desc: '热血、治愈、奇幻、恋爱全类型', count: '3,210部', icon: 'ri-rocket-line' },
  { id: 8, title: '综艺娱乐', desc: '热门综艺、搞笑真人秀、音乐节目', count: '1,543部', icon: 'ri-mic-line' },
];

export const faqData = [
  { id: 1, q: '妖精影院真的完全免费吗？需要注册吗？', a: '是的，妖精影院对所有用户完全免费开放，无需注册、无需登录、无需付费即可观看全站所有影片。我们通过网站运营维持服务，不会向用户收取任何费用。' },
  { id: 2, q: '播放视频为什么会卡顿？如何解决？', a: '如果遇到卡顿，建议先检查您的网络连接。妖精影院采用智能自适应码率技术，您也可以手动切换至较低清晰度以获得更流畅的体验。如问题持续，请尝试刷新页面或更换浏览器。' },
  { id: 3, q: '支持哪些设备观看？可以在电视上看吗？', a: '妖精影院支持PC、平板、手机等所有主流设备。移动端支持DLNA和AirPlay投屏功能，您可以一键将影片投射到智能电视上，享受大屏观影体验。' },
  { id: 4, q: '影片更新频率是怎样的？新片多久上线？', a: '我们的编辑团队全天候值守，热门新片通常在院线上映后24-48小时内完成高清版本更新。电视剧集采用同步更新模式，每周跟随播出进度及时上线最新集数。' },
  { id: 5, q: '可以下载影片离线观看吗？', a: '移动端用户可以使用离线缓存功能，将喜欢的影片下载到本地，无需网络也能随时随地观看。缓存文件经过加密处理，仅可在妖精影院应用内播放。' },
  { id: 6, q: '遇到影片无法播放怎么办？', a: '如果个别影片无法播放，可能是片源正在维护更新，建议稍后再试。您也可以通过联系页面向我们反馈问题，技术团队会第一时间处理。同时建议清除浏览器缓存后重试。' },
];

export const carouselData = [
  {
    id: 1,
    title: '暑期档必看 · 十大口碑新片',
    desc: '从动作大片到温情文艺，这个夏天最值得期待的影片都在这里了',
    tag: '编辑推荐',
    image: 'https://readdy.ai/api/search-image?query=summer%20blockbuster%20movie%20collage%20cinematic%20atmosphere%20warm%20golden%20lighting%20red%20velvet%20theater%20curtains%20dramatic%20composition%20film%20poster%20aesthetic%20rich%20textures%20elegant%20dark%20background&width=900&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '豆瓣9分以上 · 国产剧天花板',
    desc: '这些国产剧为什么能封神？深度解析高分背后的创作密码',
    tag: '深度解析',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20award%20winning%20cinematic%20scene%20elegant%20traditional%20architecture%20warm%20golden%20hour%20lighting%20artistic%20composition%20film%20poster%20style%20rich%20red%20and%20gold%20tones&width=900&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '冷门佳片 · 被埋没的宝藏电影',
    desc: '10部小众但惊艳的电影，每一部都值得你花时间细细品味',
    tag: '宝藏片单',
    image: 'https://readdy.ai/api/search-image?query=independent%20arthouse%20cinema%20aesthetic%20warm%20vintage%20film%20projector%20light%20beam%20in%20dark%20room%20dust%20particles%20floating%20atmospheric%20cinematic%20composition%20rich%20golden%20and%20crimson%20tones&width=900&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '漫改真人化 · 这些作品成功了吗',
    desc: '动漫改编真人版的得与失，漫迷和影迷的评价为何两极分化',
    tag: '热门话题',
    image: 'https://readdy.ai/api/search-image?query=anime%20live%20action%20adaptation%20cinematic%20comparison%20split%20screen%20dramatic%20lighting%20manga%20and%20film%20fusion%20artistic%20composition%20warm%20golden%20accents%20dark%20elegant%20background&width=900&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '纪录片推荐 · 真实比电影更精彩',
    desc: '精选5部高分纪录片，用镜头带你领略世界的奇妙与真实',
    tag: '纪录之选',
    image: 'https://readdy.ai/api/search-image?query=nature%20documentary%20cinematic%20scene%20golden%20sunset%20over%20vast%20landscape%20warm%20earthy%20tones%20dramatic%20skies%20artistic%20composition%20rich%20gold%20and%20amber%20colors%20elegant%20cinematography&width=900&height=500&seq=carousel-05&orientation=landscape',
  },
];

export const updatesData = [
  { id: 1, date: '2026.08.01', title: '《暗夜追踪》高清版全网首发上线', tag: '新片上架' },
  { id: 2, date: '2026.07.31', title: '《星辰大海第二季》第8集同步更新', tag: '剧集更新' },
  { id: 3, date: '2026.07.30', title: '移动端3.0版本发布：新增夜间模式与AI推荐', tag: '功能更新' },
  { id: 4, date: '2026.07.29', title: '纪录片专区全新改版，新增4K超清频道', tag: '站点公告' },
  { id: 5, date: '2026.07.28', title: '暑期档观影指南专题正式上线', tag: '专题上线' },
  { id: 6, date: '2026.07.27', title: '服务器全面升级完成，播放速度提升40%', tag: '系统维护' },
  { id: 7, date: '2026.07.26', title: '《春日暖阳》大结局上线，口碑爆棚', tag: '热门完结' },
  { id: 8, date: '2026.07.25', title: '港片经典修复计划启动，首批50部上线', tag: '经典上线' },
];

export const footerData = {
  description: '妖精影院 —— 免费在线观看高清电影电视剧的首选平台。无需付费、无需注册，即点即播不缓冲，每日更新热门新片与经典全集，致力于为每一位影迷打造极致流畅的观影体验。',
  links: [
    { title: '快速导航', items: ['热门电影', '电视剧全集', '动漫番剧', '综艺娱乐', '纪录片频道'] },
    { title: '关于我们', items: ['平台介绍', '联系我们', '用户协议', '隐私政策', '免责声明'] },
    { title: '观影指南', items: ['新手指南', '常见问题', '投屏教程', '播放问题', '片源说明'] },
  ],
};